import { StatefulTabsContextI } from "../context/TabsModalContext";
import useStatefulTabs from "./useStatefulTabs";

export type UseTabsStateReturn<T> = [StatefulTabsContextI<T>["state"], StatefulTabsContextI<T>["setState"]];

export default function useTabsState<T>(): UseTabsStateReturn<T> {
    const { state, setState } = useStatefulTabs<T>();
    return [state, setState];
}
